import { RouteConfig } from 'vue-router';
const Account = () => import('./views/account.vue');
const routers: RouteConfig[] = [
    {
        path: 'account',
        name: 'account',
        component: Account
    },
    {
        path: '*',
        redirect: 'account'
    },
];
export default routers;

